import * as actionTypes from 'store/action-types';
import { ModuleState, Action } from 'shared/interface';

const initialState: ModuleState = {
	modules: [],
	closeModal: false
}

const reducer = (state: ModuleState = initialState, action: Action): ModuleState => {
	switch (action.type) {
		case actionTypes.FETCH_MODULES_INIT:
			return {
				...state,
				modules: []
			}
		case actionTypes.FETCH_MODULES_SUCCESS:
			return {
				...state,
				modules: action.payload
			};
		case actionTypes.ADD_MODULE_SUCCESS:
			return {
				...state,
				modules: action.payload.modules,
				closeModal: true
			}
		case actionTypes.UPDATE_MODULE_SUCCESS:
			return {
				...state,
				modules: action.payload.modules,
				closeModal: true
			}
		case actionTypes.CHANGE_MODULE_STATUS_SUCCESS:
			return {
				...state,
				modules: action.payload.modules,
				closeModal: true
			}
		case actionTypes.DELETE_MODULE_SUCCESS:
			return {
				...state,
				modules: action.payload.modules,
				closeModal: true
			}
		case 'RESET_MODAL_STATUS':
			return {
				...state,
				closeModal: false
			}
		default:
			return state;
	}
}

export default reducer;
